module.exports = __webpack_public_path__ + "static/portola_valley-dd1a24cfc33ff1aa724aeb84b5c09f4f.jpg";